import { useQuery } from '@tanstack/react-query';
import { defects } from '@/utils/api';

export function useDefects(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['defects', params],
    queryFn: () => defects.getAll(params).then((r) => r.data),
  });
}

export function useDefect(id: number | string | undefined) {
  return useQuery({
    queryKey: ['defects', id],
    queryFn: () => defects.getById(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useDefectStats() {
  return useQuery({
    queryKey: ['defects', 'stats'],
    queryFn: () => defects.getStats().then((r) => r.data),
  });
}
